export default __webpack_public_path__ + "static/media/Datchik-protechki-vody.fa8bec98.webp";